import { StringUnion } from '../../utils';

export const AddressLookupCountries = StringUnion(
  'Australia'
  /*
  'New Zealand',
  'Canada',
  'United Kingdom'
  */
);
export type AddressLookupCountry = typeof AddressLookupCountries.type;
